import { render, staticRenderFns } from "./CompanyTobaForm.vue?vue&type=template&id=9b3231ac&"
import script from "./CompanyTobaForm.vue?vue&type=script&lang=js&"
export * from "./CompanyTobaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports